import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-8e068c18"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-h5 font-weight-black ps-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, { rounded: "lg" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card_title, { class: "d-flex justify-space-between align-center" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.$t('i18n.deleteDeviceModalTitle')), 1),
          _createVNode(_component_v_btn, {
            icon: "mdi-close",
            variant: "text",
            onClick: _ctx.closeModal,
            size: "x-large"
          }, null, 8, ["onClick"])
        ]),
        _: 1
      }),
      _createVNode(_component_v_card_text, { class: "overflow-y-auto" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, { align: "center" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, { cols: "auto" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, {
                    icon: "mdi-alert-outline",
                    size: "x-large"
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('i18n.confirmationMessage')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_card_actions, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_btn, {
            class: "gorate-btn-bg",
            rounded: "xl",
            text: _ctx.$t('i18n.yesBtnText'),
            onClick: _ctx.deleteDevice
          }, null, 8, ["text", "onClick"]),
          _createVNode(_component_v_btn, {
            class: "gorate-btn-bg-outlined",
            variant: "outlined",
            rounded: "xl",
            text: _ctx.$t('i18n.noBtnText'),
            onClick: _ctx.closeModal
          }, null, 8, ["text", "onClick"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}